(ns ui.wallet.i18n.ja
  "Japanese dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "読み込み中..."
   :page/command-failed "問題が発生しました。もう一度お試しいただくか、繰り返す場合はチャットでご連絡ください。"

   :balance/total-available "利用可能残高"
   :balance/pay-as-you-go "従量課金の残高"
   :balance/used-up "投稿を続けるにはクレジットを追加してください。"
   :balance/view-usage "利用状況を見る"

   :payment/title "お支払い"
   :payment/method "お支払い方法"
   :payment/billing-email "請求先メールアドレス"
   :payment/reference "参照番号"
   :payment/update "お支払い方法を変更"
   :payment/card [:fn/str "カード（{{:last4}}）"]
   :payment/wire-transfer "銀行振込"

   :billing-email/change "変更"
   :billing-email/new "新しい請求先メールアドレス"
   :billing-email/save "保存"
   :billing-email/saving "保存中..."
   :billing-email/cancel "キャンセル"
   :billing-email/hint "販売代理店のPaddleが、領収書と請求書をこのアドレスに送信します。"
   :billing-email/shared-hint "複数の組織でこの請求アカウントを共有している場合、変更はすべての組織に適用されます。"
   :billing-email/invalid "有効なメールアドレスを入力してください。"
   :billing-email/taken "このメールアドレスは別の請求アカウントで既に使用されています。別のアドレスを使用するか、チャットでお問い合わせください。"

   :customer-conflict/title "メールアドレスは既に別のアカウントに紐付いています"
   :customer-conflict/text "お使いのメールアドレスは既に別のStorrito組織の請求アカウントに登録されています。決済代行のPaddleでは、1つのメールアドレスにつき1つの請求アカウントしか作成できません。チャットでご連絡いただければ、こちらで対応いたします。"
   :customer-conflict/chat "サポートチャットを開く"
   :customer-conflict/support-message "こんにちは。決済画面を開けません。私のメールアドレスは既に別の請求アカウントに登録されています。"

   :top-up/title "自動チャージ"
   :top-up/custom-amount "任意の金額"
   :top-up/opening-checkout "決済画面を開いています..."
   :top-up/amount-missing "金額を入力してください。"
   :top-up/amount-too-small [:fn/str "最低金額は ${{:minimum}} です。"]
   :top-up/amount-too-large [:fn/str "1回のチャージの上限は ${{:maximum}} です。それ以上の金額はチャットでご相談ください。"]
   :top-up/per-month [:fn/str "毎月 ${{:quantity}}"]
   :top-up/per-year [:fn/str "毎年 ${{:quantity}}"]
   :top-up/stops-on [:fn/str "{{:date}} に終了"]
   :top-up/next-on [:fn/str "次回のチャージ: {{:date}}"]
   :top-up/status-cancellation-scheduled "解約予定"
   :top-up/status-payment-failed "お支払い失敗"
   :top-up/status-active "有効"
   :top-up/past-due "前回のチャージを請求できませんでした。"
   :top-up/update-payment-method "お支払い方法を更新してください"
   :top-up/resume "自動チャージを再開"
   :top-up/cancel "自動チャージを解約"
   :top-up/paddle-unavailable "Paddle から自動チャージの情報を読み込めませんでした。しばらくしてからもう一度お試しください。"
   :top-up/try-again "再試行"

   :plan/title-monthly "毎月のチャージ"
   :plan/title-yearly "毎年のチャージ"
   :plan/switch "従量課金に切り替える"
   :plan/switching "切り替えています..."
   :plan/switch-confirm [:fn/str "毎回の ${{:quantity}} のチャージは今終了します。切り替えは無料です。残高とお支払い方法はそのまま残ります。以降はクレジットを追加したときだけ、または自動チャージで自動的にお支払いいただきます。"]
   :plan/wont-cover [:fn/str "残高では、{{:date}} の次回チャージまで連携中の Instagram アカウントをまかなえない可能性があります。残高が $0 になるとストーリーの投稿が止まります。"]
   :plan/wont-cover-advice "下の自動チャージをオンにするか、今すぐクレジットを追加してください。"

   :on-demand/add-credits "クレジットを追加"
   :on-demand/choose-amount "金額を選んでください。お支払いは利用した分だけです。"
   :on-demand/auto-top-up "自動チャージ"
   :on-demand/rule [:fn/str "残高が ${{:threshold}} を下回ると、自動的に ${{:amount}} を追加します。"]
   :on-demand/auto-top-up-hint "任意。残高が少なくなってもストーリーの投稿が止まりません。いつでもオフにできます。"
   :on-demand/add [:fn/str "${{:amount}} を追加"]
   :on-demand/charged-once "販売代理店 Paddle を通じて今回1回のみ請求されます。カードは今後のチャージのために保存され、定期的な請求はありません。クレジットは返金できません。価格は消費税別です。"
   :on-demand/discount-off [:fn/str "{{:percent}}% オフ:"]
   :on-demand/discount-applied "初回チャージ以降、日額料金に適用されます。チャージ金額には適用されません。ウェルカムクレジットは通常料金で請求されます。"
   :on-demand/charged-to-card "保存されたお支払い方法に請求され、数秒で利用できます。"
   :on-demand/confirm-charge [:fn/str "今すぐ ${{:amount}} USD（税別）が請求されます。"]
   :on-demand/charging "請求中..."
   :on-demand/add-now [:fn/str "今すぐ ${{:amount}} を追加"]
   :on-demand/payment-accepted "お支払いが完了しました。残高は数秒で更新されます。"
   :on-demand/prices-excl-vat "価格は消費税別です。"
   :on-demand/amount-too-large [:fn/str "1回のチャージの上限は ${{:maximum}} です。"]
   :on-demand/on "オン"
   :on-demand/off "オフ"
   :on-demand/saving "保存中..."
   :on-demand/save "保存"
   :on-demand/custom-auto-top-up-amount "自動チャージの任意の金額"
   :on-demand/one-charge-per-day "自動請求は1日1回まで、保存されたお支払い方法に、適用される税を加えて請求されます。"
   :on-demand/remove-payment-method "お支払い方法を削除"

   :transactions/title "最近の取引"
   :transactions/full-statement "明細をすべて見る"
   :transactions/invoices "請求書"
   :transactions/date "日付"
   :transactions/description "内容"
   :transactions/amount "金額"
   :transactions/error "取引を読み込めませんでした。"
   :transactions/empty "今月の購入はまだありません。"
   :transactions/welcome-credits "ウェルカムクレジット"
   :transactions/recurring-top-up "定期チャージ"
   :transactions/added-credits "クレジット追加"
   :transactions/refund "クレジットの返金"

   :credit-notes/view "クレジットノート"
   :credit-notes/title "クレジットノート"
   :credit-notes/intro "返金とクレジットのクレジットノートです。販売代理店の Paddle が発行します。"
   :credit-notes/refund "返金"
   :credit-notes/credit "クレジット"
   :credit-notes/download "PDF をダウンロード"
   :credit-notes/empty "クレジットノートはまだありません。"
   :credit-notes/error "クレジットノートを読み込めませんでした。"

   :offer/applied-automatically "クレジットを追加すると自動的に適用されます。それまでのウェルカムクレジットは通常料金で請求されます。"

   :rates/view "料金を見る"
   :rates/title "料金一覧"
   :rates/intro "サービスごとの料金は次のとおりです。"
   :rates/intro-bold "すべての価格は米ドル建て、税別（消費税別）です。"
   :rates/per-day "1日あたり"
   :rates/per-post "1投稿あたり"
   :rates/per-image "1画像あたり"
   :rates/per-days [:fn/str "{{:days}}日あたり"]
   :rates/excl-vat "すべての価格は消費税別"
   :rates/off [:fn/str "{{:percent}}% OFF"]

   :service.storage-flat-fee/name "ストレージ定額料金"
   :service.storage-flat-fee/description "画像や動画などすべてのファイルの保存"
   :service.instagram-connection/name "Instagram アカウント連携"
   :service.instagram-connection/description "1つの Instagram ユーザー名でストーリーとリールが無制限。"
   :service.tiktok-post/name "TikTok 投稿"
   :service.tiktok-post/description "TikTok に動画または画像を投稿。"
   :service.youtube-short/name "YouTube ショート"
   :service.youtube-short/description "レンダリングした動画を YouTube ショートとして投稿。"
   :service.social-post/name "ソーシャル投稿"
   :service.social-post/description "レンダリングした動画や画像を Facebook、Threads などの連携プラットフォームに投稿（X は別料金）。"
   :service.x-post/name "X 投稿"
   :service.x-post/description "レンダリングした動画を X に投稿。X は API 経由の投稿ごとに料金を請求するため、X 投稿は他のソーシャル投稿より高くなります。"
   :service.x-post-link/name "リンク付き X 投稿"
   :service.x-post-link/description "本文にリンクを含む X 投稿。X はリンク付きの投稿にかなり高い料金を請求します。"
   :service.ai-image/name "AI 画像"
   :service.ai-image/description "AI による画像生成（Dall-e / Blackforest）。"})
